export default __webpack_public_path__ + "static/media/1.10ea1a69.webp";